import { createFileRoute } from '@tanstack/react-router';
import { Results } from '@/components';

export const Route = createFileRoute('/results')({
  component: Results,
});
